// extracted by mini-css-extract-plugin
module.exports = {"list":"QuizzesList_list__2p_RU","empty":"QuizzesList_empty__T8GLA","info":"QuizzesList_info__1UwzH"};